import axiosClient from "./axiosClient";

const budgetService = {
    // Used for Task creation dropdowns (returns only active)
    getActiveBudgets: async () => {
        const response = await axiosClient.get('budget_ranges.php');
        return response.data;
    },

    // Used for the Admin Settings page (returns all including hidden)
    getAdminBudgets: async () => {
        const response = await axiosClient.get('budget_ranges.php?all=true');
        return response.data;
    },

    createBudget: async (label) => {
        const response = await axiosClient.post('budget_ranges.php', { range_label: label });
        return response.data;
    },

    updateBudget: async (id, data) => {
        // data should include { range_label, is_active }
        const response = await axiosClient.put(`budget_ranges.php?id=${id}`, data);
        return response.data;
    },

    deleteBudget: async (id) => {
        // Soft delete: sets is_active to 0 in PHP
        const response = await axiosClient.delete(`budget_ranges.php?id=${id}`);
        return response.data;
    },

    getBudgetStats: async (id) => {
        // Returns the count of enquiries linked to this budget
        const response = await axiosClient.get(`budget_ranges.php?id=${id}&stats=true`);
        return response.data;
    },

    purgeBudget: async (id) => {
        // Hard delete: wipes the budget and all linked enquiries
        const response = await axiosClient.delete(`budget_ranges.php?id=${id}&purge=true`);
        return response.data;
    }
};

export default budgetService;